import { useRouter } from 'next/router';
import {
  findValueByKey,
  getImage,
  getTarget,
  isItUndefined,
  isLinkAbsolute,
  noTruncationForAllScreen,
  removeNbsp,
  stripHtml,
} from '../../util/DataUtil';
import { useEffect, useState } from 'react';
import ArticleThumbnailCard from '../shared/ArticleThumbnailCard';

const ResourcePopular = ({ posts, title, onChipClick, width }) => {
  if (posts.length === 0) {
    return '';
  }

  const router = useRouter();
  const [titles, setTitles] = useState([]);

  const truncate = () => {
    const titles = posts.map((item) => {
      const templateTitle = isItUndefined(
        item?.field_template_blocks?.template_title_block_type
          ?.field_template_title
      );
      const heroFormattedTitle = isItUndefined(
        item?.field_template_blocks?.hero_graphic_block_type
          ?.field_formatted_title
      );

      if (!templateTitle && !heroFormattedTitle) {
        return '';
      }

      return [
        noTruncationForAllScreen(templateTitle, 63, 43, 45, 18, 32, 37, width),
        noTruncationForAllScreen(
          removeNbsp(stripHtml(heroFormattedTitle)),
          63,
          43,
          45,
          18,
          32,
          37,
          width
        ),
      ];
    });

    setTitles(titles);
  };

  useEffect(() => {
    truncate();
  }, [posts]);

  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });

    useEffect(() => {
      // only execute all the code below in client side
      if (typeof window !== 'undefined') {
        // Handler to call on window resize
        function handleResize() {
          // Set window width/height to state
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
      }
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  // Image URL for the shared card (banner bynder → web small → hero image).
  const getPostImageSrc = (item) =>
    getImage(
      item?.field_template_blocks?.template_banner_block_type
        ?.field_template_banner_bynder?.webimage,
      item?.field_template_blocks?.template_banner_block_type
        ?.field_web_small_image?.webimage,
      item?.field_template_blocks?.hero_graphic_block_type?.webimage
    );

  // Subheader meta: content type in the author's position + time to read
  // (same blog-info structure/classes as Blog so the shared card styles it).
  const renderMeta = (item) => {
    const label = item?.field_content_type_templat?.[0]?.name;
    const time = item?.field_time_to_read?.[0]?.value;
    if (!label && !time) return null;
    return (
      <div className={'blog-info'}>
        {label ? <span className={'info-item'}>{label}</span> : null}
        {label && time ? (
          <span className={'separator separator-inline info-item'}>
            {' | '}
          </span>
        ) : null}
        {time ? <span className={'blog-read-time info-item'}>{time}</span> : null}
      </div>
    );
  };

  const handleTagClick = (event, tag) => {
    if (tag?.name) {
      onChipClick(event, [{ name: tag.name }]);
    }
  };

  const renderPosts = () => {
    return posts.map((item, index) => (
      <ArticleThumbnailCard
        key={`popular-${item?.objectID || item?.['url-alias'] || index}`}
        className="item"
        href={item?.['url-alias']?.length ? item['url-alias'] : '/'}
        target={getTarget(item?.['url-alias'])}
        image={getPostImageSrc(item)}
        imageAlt="resource-popular"
        header={
          isItUndefined(item?.field_display_title)
            ? isItUndefined(item?.field_display_title)
            : titles[index]
        }
        subheader={renderMeta(item)}
        primaryCategory={item?.field_template_category?.[0]}
        secondaryCategories={item?.field_template_secondary_categor}
        onTagClick={handleTagClick}
      />
    ));
  };

  return (
    <div className={'resource-popular'}>
      <div className={'inner-container'}>
        <span className={'page-sub'}>{title}</span>
        <hr />
        <div className={'posts'}>{renderPosts()}</div>
      </div>
    </div>
  );
};

export default ResourcePopular;
